module.exports = __webpack_public_path__ + "img/chevron-forward.725b19f4.svg";